import { render, staticRenderFns } from "./ResultadoIndicadores.vue?vue&type=template&id=7e8d2080&scoped=true"
import script from "./ResultadoIndicadores.vue?vue&type=script&lang=js"
export * from "./ResultadoIndicadores.vue?vue&type=script&lang=js"
import style0 from "./ResultadoIndicadores.vue?vue&type=style&index=0&id=7e8d2080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d2080",
  null
  
)

export default component.exports